/*
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-04-09 18:24:54
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-08-28 10:40:17
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\config\routes\application.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default [
  {
    path: '/portal/application',
    name: 'portal-application',
    component: () => import('@/views/portal/application/index.vue'),
    meta: {
      title: '应用列表',
      icon: 'intelligent',
    },
  },
  {
    path: '/portal/application/setting/:phid',
    name: 'portal-application-setting',
    component: () => import('@/views/portal/application/setting/index.vue'),
    meta: {
      title: '应用配置',
      noPadding: true,
      show: false,
    },
  },
  {
    path: '/portal/kbase',
    name: 'portal-kbase',
    component: () => import('@/views/portal/Knowledge/index.vue'),
    meta: {
      title: '知识库',
      icon: 'menu',
    },
  },
  {
    path: '/portal/kbase/qa/:type/:phid',
    name: 'portal-kbase-qa',
    component: () => import('@/views/portal/Knowledge/qa.vue'),
    meta: {
      title: 'QA知识库',
      show: false,
    },
  },
  {
    path: '/portal/kbase/doc/:type/:phid',
    name: 'portal-kbase-doc',
    component: () => import('@/views/portal/Knowledge/doc.vue'),
    meta: {
      title: '文档知识库',
      show: false,
    },
  },
  {
    path: '/portal/kbase/detail/doc/:phid',
    name: 'portal-kbase-detail-doc',
    component: () => import('@/views/portal/Knowledge/detail-doc.vue'),
    meta: {
      title: '文档知识库详情',
      show: false,
    },
  },
  {
    path: '/portal/history',
    name: 'portal-history',
    component: () => import('@/views/portal/history/index.vue'),
    meta: {
      title: '历史记录',
      icon: 'user',
    },
  },
  // {
  //   path: '/portal/userCenter',
  //   name: 'portal-user-center',
  //   component: () => import('@/views/portal/userCenter/index.vue'),
  //   meta: {
  //     title: '用户信息',
  //     icon: 'user',
  //   },
  // },
];
